/**
 * Shows a warning when more than one variant is selected for the same title (CMRP).
 */
(function () {
  const MESSAGE =
    'Heads up! You have selected more than one format for this title.';

  window.ProductSystem = window.ProductSystem || {};

  window.ProductSystem.MULTI_FORMAT_SELECTION_WARNING_MARKUP =
    '<div class="multi-format-selection-warning" hidden role="status">' +
    MESSAGE +
    '</div>';

  /**
   * @param {Element | null | undefined} scope
   */
  function updateMultiFormatSelectionWarning(scope) {
    if (!scope) return;

    const warning = scope.querySelector('.multi-format-selection-warning');
    if (!warning) return;

    const selectedCount = scope.querySelectorAll('.purchase-checkbox:checked').length;
    warning.hidden = selectedCount < 2;
  }

  /**
   * @param {Element | null | undefined} scope
   */
  function initMultiFormatSelectionWarning(scope) {
    if (!scope || scope.hasAttribute('data-multi-format-warning-init')) return;

    scope.setAttribute('data-multi-format-warning-init', 'true');
    scope.addEventListener(
      'change',
      function (event) {
        if (event.target?.classList?.contains('purchase-checkbox')) {
          updateMultiFormatSelectionWarning(scope);
        }
      },
      true
    );
    updateMultiFormatSelectionWarning(scope);
  }

  window.ProductSystem.updateMultiFormatSelectionWarning =
    updateMultiFormatSelectionWarning;
  window.ProductSystem.initMultiFormatSelectionWarning =
    initMultiFormatSelectionWarning;
})();
